import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import axiosInstance from "../../config/axiosConfig";
import config from "../../config/api";

const BackendURL = config.backendUrl;

export const updateManagerAction = createAsyncThunk(
    "managerAction/updateManagerAction",
    async (payload, { rejectWithValue }) => {
        try {
            const response = await axiosInstance.post(`${BackendURL}/managerProjectRequested/manager-action-complete`, payload);
            return response.data;
        } catch (error) {
            return rejectWithValue(
                error.response?.data?.message || "Failed to update manager action"
            );
        }
    }
);

const managerActionSlice = createSlice({
    name: "managerAction",
    initialState: {
        loading: false,
        success: false,
        error: null,
        message: null,
    },
    reducers: {
        resetManagerAction: (state) => {
            state.loading = false;
            state.success = false;
            state.error = null;
            state.message = null;
        },
    },
    extraReducers: (builder) => {
        builder
            .addCase(updateManagerAction.pending, (state) => {
                state.loading = true;
                state.success = false;
                state.error = null;
            })
            .addCase(updateManagerAction.fulfilled, (state, action) => {
                state.loading = false;
                state.success = true;
                state.message = action.payload?.message || "Updated successfully";
            })
            .addCase(updateManagerAction.rejected, (state, action) => {
                state.loading = false;
                state.success = false;
                state.error = action.payload || "Something went wrong";
            });
    },
});

export const { resetManagerAction } = managerActionSlice.actions;
export default managerActionSlice.reducer;
